export default {
  methods: {
    /**
     * Create the script tag with the json+ld generated BreadcrumbList.
     *
     * @param {Object[]} jsonld - The jsonld object.
     * @param {string} jsonld.name - The name shown for this element.
     * @param {Number} jsonld.position - The jsonld's position.
     * @param {string} jsonld.item - The jsonld's url for the refered element.
     *
     * @returns {string} the script tag with the generated json+ld to append on DOM.
     */
    createBreadcrumbListScript(jsonld = false, returnObject = false) {
      const breadcrumbTemplate = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': []
      }

      if (jsonld) {
        const listLength = jsonld.length
        for (let i = 0; i < listLength; i++) {
          breadcrumbTemplate.itemListElement[i] = {
            '@type': 'ListItem',
            'position': jsonld[i].position,
            'name': jsonld[i].name,
            'item': jsonld[i].item
          }
        }
      }

      if (returnObject) {
        return breadcrumbTemplate
      } else if (process.browser) {
        const scriptElement = document.createElement('script')
        scriptElement.setAttribute('type', 'application/ld+json')
        scriptElement.innerHTML = JSON.stringify(breadcrumbTemplate)
        return scriptElement
      }
    },
    createAutoRentalSchemaScript(jsonld = false, returnObject = false) {
      if (jsonld.reviewCount) {
        const schemaTemplate = {
          '@context': 'https://schema.org',
          '@type': 'AutoRental',
          'name': jsonld.name,
          'image': jsonld.image,
          'aggregateRating': {
            '@type': 'AggregateRating',
            'ratingValue': jsonld.ratingValue,
            'bestRating': jsonld.bestRating,
            'worstRating': jsonld.worstRating,
            'reviewCount': jsonld.reviewCount
          }
        }
        if (returnObject) {
          return schemaTemplate
        } else if (process.browser) {
          const scriptElement = document.createElement('script')
          scriptElement.setAttribute('type', 'application/ld+json')
          scriptElement.innerHTML = JSON.stringify(schemaTemplate)
          return scriptElement
        }
      }
    },
    createLocalBusinessSchemaScript (jsonld = {}, returnObject = false) {
      const schemaTemplate = {
        '@context': 'http://schema.org',
        '@type': 'LocalBusiness',
        ...jsonld
      }
      if (returnObject) {
        return schemaTemplate
      } else if (process.browser) {
        const scriptElement = document.createElement('script')
        scriptElement.setAttribute('type', 'application/ld+json')
        scriptElement.innerHTML = JSON.stringify(schemaTemplate)
        return scriptElement
      }
    },
    createSchemaFromLocalBusiness (rentalStore = []) {
      try {
        const { priceRange, url } = rentalStore
        return {
          url,
          name: `${rentalStore.Bandeira.Nome} - ${rentalStore.Endereco.Endereco}`,
          image: this.$rentcarsCdn(rentalStore.Bandeira.LogoMarca, true),
          areaServed: {
            '@type': 'City',
            name: rentalStore.Endereco.Cidade,
            latitude: rentalStore.Endereco.Latitude,
            longitude: rentalStore.Endereco.Longitude
          },
          parentOrganization: {
            '@type': 'Organization',
            name: rentalStore.Bandeira.Nome
          },
          address: {
            '@type': 'PostalAddress',
            streetAddress: rentalStore.Endereco.Endereco,
            addressLocality: rentalStore.Endereco.Cidade,
            postalCode: rentalStore.Endereco.Cep,
            addressCountry: rentalStore.Endereco.Pais
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: rentalStore.Endereco.Latitude,
            longitude: rentalStore.Endereco.Longitude
          },
          telephone: rentalStore.Telefone && rentalStore.Telefone.telefone
            ? rentalStore.Telefone.telefone
            : '',
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: rentalStore.HorarioFuncionamento.DiasDaSemana ?? null,
            opens: rentalStore.HorarioFuncionamento.HoraInicio ?? null,
            closes: rentalStore.HorarioFuncionamento.HoraFim ?? null
          },
          priceRange
        }
      } catch (e) {
        this.$bugsnag.notify(e)
      }
    },
    createdLocationScript (jsonld = {}) {
      return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        ...jsonld
      }
    }
  }
}
